module.exports = __webpack_public_path__ + "img/notviewicon.5a3a887b.svg";